export default {
    roles: {
        admin: 'Admin',
        owner: 'Owner',
        member: 'Member',
        developer: 'Developer',
        agent: 'Agent',
        sales: 'Sales',
    },
    status: {
        active: 'Active',
        pending: 'Pending',
        inactive: 'Inactive',
    },
    filters: {
        search: 'Search by name',
        status: 'Status',
        role: 'Role',
    },
    headers: {
        name: 'Name',
        description: 'Description',
        'date-added': 'Date added',
        email: 'Email',
        title: 'Title',
        status: 'Status',
        role: 'Role',
        actions: 'Actions',
        permissions: 'Permissions',
        'last-invitation-sent': 'Last invitation sent',
    },
    invite: {
        title: 'Invite new member',
        name: 'Name',
        surname: 'Surname',
        email: 'Email',
    },
    edit: {
        title: 'Edit member profile',
        'organization-info': 'Changes will only apply to your profile in this organization.',
        'success-notification': 'Profile has been updated successfully!',
    },
    invitations: {
        title: 'Invitations',
    },
    actions: {
        reinvite: 'Re-invite',
        manage: 'Manage',
        block: 'Block',
        activate: 'Activate',
    },
    membership: {
        'add-member': 'Add new member',
    },
    'success-notification': 'The invitation has been sent to {email}!',
    'configure-roles': {
        title: 'Manage roles',
        'add-new': 'Add new role',
        search: 'Search by name',
        groups: {
            definition: 'Definition',
            data: 'Data',
            attachments: 'Attachments',
            comment: 'Comments',
        },
        levels: {
            edit: 'Edit',
            read: 'Read',
            none: 'None',
            inherit: 'Inherit',
            comment: 'Comment',
        },
    },
}
